import { DataSnapshot, getDatabase, ref, onValue, Unsubscribe } from 'firebase/database';

import { firebaseApp } from './firebaseConfig';
import { breadcrumb, logError } from '../logging';
import { objectToArray } from '../utils';
import { ConnectedDevice } from '@synergetx/puppet-interview-types';

const database = () => getDatabase(firebaseApp);

export function getDevices(
    selectedInterviewId: string,
    selectedGroupId: string,
    onUpdate: (devices: ConnectedDevice[]) => void,
): Unsubscribe {
    return onValue(
        ref(database(), `/Groups/${selectedGroupId}/${selectedInterviewId}`),
        (doc: DataSnapshot) => {
            const exists = doc.exists();
            if (exists) {
                const data = doc.val();
                // objectToArray passes nullish input through, so guard rather than cast.
                const connectedDevices = objectToArray<ConnectedDevice>(data);
                onUpdate(Array.isArray(connectedDevices) ? connectedDevices : []);
            } else {
                onUpdate([]);
            }
        },
        (error: Error) => {
            breadcrumb('getDevices error', 'realtime DB', {
                selectedInterviewId,
                selectedGroupId,
            });
            logError(error);
            onUpdate([]);
        },
    );
}
